import React from "react"

export default function HighlightLinks(text) {
	const urlRegex = /(https?:\/\/[^\s]+)/g

	return text.split(urlRegex).map((part, index) => {
		if (urlRegex.test(part)) {
			return (
				<a
					key={index}
					href={part}
					target="_blank"
					rel="noopener noreferrer"
					className="text-blue-600 underline font-medium hover:text-blue-800"
				>
					{part}
				</a>
			)
		}
		return <span key={index}>{part}</span>
	})
}
